
const downloads = {
    pcDownloadUrl: 'https://launcher-public-service-prod06.ol.epicgames.com/launcher/api/installer/download/EpicGamesLauncherInstaller.msi',
    macDownloadUrl: 'https://launcher-public-service-prod06.ol.epicgames.com/launcher/api/installer/download/EpicGamesLauncher.dmg'
};

module.exports = downloads;



/** WEBPACK FOOTER **
 ** ./app/scripts/constants/downloads.js
 **/